exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._6xWLkC0zzzEtXfn2wiiVy{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;-ms-flex-wrap:wrap;flex-wrap:wrap}html[dir=ltr] ._6xWLkC0zzzEtXfn2wiiVy._3MZ1jJd5cATBMgg6x1E2Jh>*{margin-right:10px}html[dir=ltr] ._6xWLkC0zzzEtXfn2wiiVy.ufUwc6IOgxQbfbVCcPbv9>*,html[dir=rtl] ._6xWLkC0zzzEtXfn2wiiVy._3MZ1jJd5cATBMgg6x1E2Jh>*{margin-left:10px}html[dir=rtl] ._6xWLkC0zzzEtXfn2wiiVy.ufUwc6IOgxQbfbVCcPbv9>*{margin-right:10px}", ""]);

// exports
exports.locals = {
	"workWeek": "_6xWLkC0zzzEtXfn2wiiVy",
	"ltr": "_3MZ1jJd5cATBMgg6x1E2Jh",
	"rtl": "ufUwc6IOgxQbfbVCcPbv9"
};